import { Check, Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../app/providers/locale-provider';
import { cn } from '../lib/utils';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export const LanguageSwitcher = ({
  contentClassName,
  triggerClassName,
}: {
  contentClassName?: string;
  triggerClassName?: string;
}) => {
  const { availableLocales, locale, changeLanguage } = useLocale();
  const { t } = useTranslation('common');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={cn('inline-flex items-center gap-2', triggerClassName)}
          aria-label={t('languageSwitcher.ariaLabel')}
        >
          <Languages className="h-4 w-4" />
          <span className="hidden text-sm font-medium sm:inline-block">
            {t('languageSwitcher.buttonLabel')}
          </span>
          <span className="text-xs font-semibold uppercase">{locale}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={contentClassName}>
        {availableLocales.map((option) => {
          const isActive = option.id === locale;
          const label = t(`language.names.${option.id}`, { defaultValue: option.label });
          return (
            <DropdownMenuItem
              key={option.id}
              className="flex items-center justify-between gap-2"
              onSelect={(event) => {
                event.preventDefault();
                if (!isActive) {
                  void changeLanguage(option.id);
                }
              }}
            >
              <span className="text-sm font-medium">{label}</span>
              {isActive ? <Check className="h-4 w-4 text-primary" /> : null}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
